export enum NftConfigStatus {
  Created = 'created',
  Minting = 'minting',
  Minted = 'minted',
}
